import { mediaGQLFields } from '../media/media.fields.js';
import { memberGQLFields } from '../network/member.fields.js';
import { spaceAuthMemberPropsGQLFields, } from '../permission/spaceAuthMemberProps.fields.js';
import { slateGQLFields } from '../slate/slate.fields.js';
import { collectionGQLFields } from './collection.fields.js';
import { highlightedTagGQLFields, } from './highlightedTag.fields.js';
import { spaceMembersGQLFields, } from './spaceMembers.fields.js';
import { spacePostsGQLFields } from './spacePosts.fields.js';
import { spaceSeoDetailGQLFields, } from './spaceSeoDetail.fields.js';
const BASIC_SPACE_FIELDS = {};
const ALL_SPACE_FIELDS = {
    seoDetail: 'basic',
    postsCount: 'basic',
    image: 'basic',
    banner: 'basic',
    highlightedTags: 'basic',
    createdBy: 'basic',
    collection: 'basic',
    authMemberProps: 'basic',
    slate: 'all',
};
const DEFAULT_SPACE_FIELDS = {
    authMemberProps: 'all',
    banner: 'basic',
    image: 'basic',
    postsCount: 'basic',
    highlightedTags: 'basic',
    slate: 'all',
    collection: 'basic',
};
export function spaceGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_SPACE_FIELDS;
    if (fields === 'all')
        fields = ALL_SPACE_FIELDS;
    if (fields === 'default')
        fields = DEFAULT_SPACE_FIELDS;
    return `
    id
    networkId
    name
    description
    slug
    type
    layout
    address {
      path
      exact
      editable
    }
    createdById
    groupId
    imageId
    bannerId
    membersCount
    createdAt
    private
    hidden
    inviteOnly
    nonAdminsCanInvite
    customOrderingIndexInGroup
    whoCanPost
    whoCanReact
    whoCanReply
    customSeoDetail {
      description
      noIndex
      thumbnail {
        ${mediaGQLFields()}
      }
      thumbnailId
      title
    }
    relativeUrl
    url
    ${fields.postsCount ? `postsCount` : ``}
    ${fields.image
        ? `
      image {
        ${mediaGQLFields(fields.image)}
      }
    `
        : ``}
    ${fields.banner
        ? `
      banner {
        ${mediaGQLFields(fields.banner)}
      }
    `
        : ``}
    ${fields.highlightedTags
        ? `
      highlightedTags {
        ${highlightedTagGQLFields(fields.highlightedTags)}
      }

    `
        : ``}
    ${fields.seoDetail
        ? `
      seoDetail {
        ${spaceSeoDetailGQLFields(fields.seoDetail)}
      }
    `
        : ``}
    ${fields.createdBy
        ? `
      createdBy {
        ${memberGQLFields(fields.createdBy)}
      }
    `
        : ``}
    ${fields.collection
        ? `
      collection {
        ${collectionGQLFields(fields.collection)}
      }
    `
        : ``}
    ${fields.authMemberProps
        ? `
      authMemberProps {
        ${spaceAuthMemberPropsGQLFields(fields.authMemberProps)}
      }
    `
        : ``}
    ${fields.slate
        ? `
        slate {
          ${slateGQLFields('all')}
        }
    `
        : ``}
    ${fields.members ? spaceMembersGQLFields(fields.members) : ``}
    ${fields.posts ? spacePostsGQLFields(fields.posts) : ``}
  `;
}
//# sourceMappingURL=space.fields.js.map